import styled, { css } from 'styled-components';

export const StyledMicrosoftButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  padding: 10px 30px;

  background-color: #ffffff;
  border: 1px solid #8c8c8c;
  border-radius: 5px;

  color: #5e5e5e;
  font-size: 0.95rem;
  font-weight: 500;

  cursor: pointer;
  transition: opacity ease-in 0.15s;

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: default;
          opacity: 0.6;
        `
      : css`
          &:hover {
            opacity: 0.85;
          }
          &:active {
            transform: scale(0.98);
          }
        `}
`;
